"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DashboardLayoutGridRow = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var react_grid_system_1 = require("react-grid-system");
var DashboardLayoutItem_1 = require("./DashboardLayoutItem");
var defaultItemKeyGetter = function (_a) {
    var item = _a.item;
    return item.index().toString();
};
function DashboardLayoutGridRow(props) {
    var section = props.section, _a = props.itemKeyGetter, itemKeyGetter = _a === void 0 ? defaultItemKeyGetter : _a, gridRowRenderer = props.gridRowRenderer, itemRenderer = props.itemRenderer, widgetRenderer = props.widgetRenderer, screen = props.screen, items = props.items, renderMode = props.renderMode;
    var rowItems = items.map(function (item) { return (react_1.default.createElement(DashboardLayoutItem_1.DashboardLayoutItem, { key: itemKeyGetter({ item: item, screen: screen }), item: item, itemRenderer: itemRenderer, widgetRenderer: widgetRenderer, screen: screen })); });
    return (react_1.default.createElement(react_grid_system_1.Row, { className: "gd-fluidlayout-row s-gd-fluid-layout-row" }, gridRowRenderer
        ? gridRowRenderer({
            children: rowItems,
            screen: screen,
            section: section,
            items: items,
            renderMode: renderMode,
        })
        : rowItems));
}
exports.DashboardLayoutGridRow = DashboardLayoutGridRow;
//# sourceMappingURL=DashboardLayoutGridRow.js.map